import React, { useEffect, useState } from 'react'
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/Components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { Button } from '@/Components/ui/button'
import UserService from '@/Service/UserService'
import { Spinner } from '../ui/spinner'
import { Check, Info } from 'lucide-react'
import { cn } from '@/lib/utils'

const GroupConfigurationSearchableDropdown = ({ options, handleSelected, selectedValue, searchFilter }) => {
    const [open, setOpen] = useState(false)
    const [query, setQuery] = useState('')
    const [loading, setLoading] = useState(false)
    const [filteredOptions, setFilteredOptions] = useState(options)
    useEffect(() => {
        const delayDebounce = setTimeout(async () => {
            if (query) {
                setLoading(true)
                try {
                    const resp = await UserService.getUsersByRole({ email: query, name: query, ...searchFilter })
                    if (resp.data.success) {
                        setFilteredOptions(resp.data.data)
                    } else {
                        setFilteredOptions([])
                    }
                } catch (error) {
                    console.log('err', error)
                    setFilteredOptions([])
                } finally {
                    setLoading(false)
                }
            } else {
                setFilteredOptions(options)
            }
        }, 300)

        return () => clearTimeout(delayDebounce)
    }, [query])

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild onClick={() => setOpen(true)}>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="border-0 w-full focus-within:shadow-none focus:shadow-none shadow-none justify-between hover:bg-transparent active:shadow-none px-1 text-wrap text-left disabled-focus-style"
                >
                    {selectedValue ? <span>{selectedValue}</span> : <span className="text-gray-300">Search Employee...</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[250px] p-0">
                <Command>
                    <CommandInput
                        placeholder="Search Employee..."
                        value={query}
                        onValueChange={setQuery}
                        className="border-0 shadow-none focus:shadow-non focus-within:shadow-none"
                    />
                    <CommandList className="max-h-40">
                        {loading ? (
                            <div className="flex justify-center items-center py-2">
                                <Spinner size="small" />
                            </div>
                        ) : filteredOptions.length > 0 ? (
                            <CommandGroup>
                                {filteredOptions.map((option) => (
                                    <CommandItem
                                        key={option.email}
                                        value={option.email}
                                        onSelect={() => {
                                            handleSelected(option.email, option)
                                            setOpen(false)
                                        }}
                                    >
                                        <div className="flex flex-col">
                                            <span className="text-sm font-semibold">{option.full_name}</span>
                                            <span className="text-xs text-gray-500">{option.email}</span>
                                        </div>
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        ) : (
                            <CommandEmpty>No employee found.</CommandEmpty>
                        )}
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    )
}

export default GroupConfigurationSearchableDropdown
